const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const string_pattern = /^[a-z]+$/i;
const number_pattern = /^-?\d+$/;
const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(:[0-9]{1,5})?(\/[^\s]*)?$/i;

const validateInput = (input, pattern, errMsg) => {
  pattern.test(input.value.trim()) ? Remove_Element(input) : Create_Element(input, errMsg);
};

const errorFieldWrapper = document.querySelector('.error-message').parentElement.getAttribute('class');

document.getElementById('bestTimeToCall').addEventListener('change', function () {
  const errorElem = document.querySelector('#best_timeErr');
  this.value ? errorElem.classList.add('hidden') : errorElem.classList.remove('hidden');
  errorElem.classList.toggle('error-message', !this.value);
});
const handleInputKeyUp = function () {
  const { type, id, value } = this;
  if (type === "email") {
    validateInput(this, email_pattern, value.trim() === '' ? 'Please enter your Email Address' : 'Invalid Email Address');
  } else if (type === "text" && (id === "firstName" || id === "lastName" || id == 'RegisterForm-followers' || id =='RegisterForm-link')) {
    validateInput(this, string_pattern, value.trim() === '' ? `Please enter your ${id === 'firstName' ? 'First' : 'Last'} Name.` : 'Special characters and numbers are not allowed.');
    if(id =='RegisterForm-link'){
      validateInput(this, urlRegex, value.trim() === '' ? 'Please enter your Number of Followers.' : 'Invalid Profile link');
    }
  } else if (type === "tel") {
    validateInput(this, number_pattern, value.trim() === '' ? `Please enter your ${id === 'ContactForm-phone' ? 'Phone Number' : 'Number of Followers' }.` : `${id === 'ContactForm-phone' ? 'Phone number must be a number.' : 'Please enter your Number of Followers.' }`);
  }
};

document.querySelectorAll('input').forEach(input => input.addEventListener('keyup', handleInputKeyUp));

const Create_Element = (ele, errMsg) => {
  const errorElem = ele.closest(`.${errorFieldWrapper}`).querySelector('.error-message');
  if (errorElem) errorElem.remove();
  const newErrorElem = document.createElement("p");
  newErrorElem.classList.add("error-message");
  newErrorElem.textContent = errMsg;
  ele.closest(`.${errorFieldWrapper}`).appendChild(newErrorElem);
};

const Remove_Element = (ele) => {
  const errorElem = ele.closest(`.${errorFieldWrapper}`).querySelector('.error-message');
  if (errorElem) errorElem.remove();
};

document.querySelector('.contactUs-btn').addEventListener('click',function(evt){
  evt.preventDefault();
  let errorMsg = document.querySelectorAll('.error-message');
  errorMsg.forEach((item,index)=>{
    item.classList.remove('hidden');
  })
  if(errorMsg.length == 0){
    this.closest('form').submit();
  }
})